import React from 'react'
import { MobilePaginationBar } from '../../components/mobile'

const OrderMobilePagination = ({ pagination, handlePagination }) => {
  return (
    <MobilePaginationBar
      current_page={pagination?.current_page}
      total_pages={pagination?.total_pages}
      onNavigate={handlePagination}
      ariaLabel="Paginación de pedidos"
      disablePaper
    />
  )
}

export default OrderMobilePagination
